const DATA_AUTOMATION_ID_ATTRIBUTE = 'data-automation-id';

export function generateDataAutomationIdAttribute(name: string): {
	[DATA_AUTOMATION_ID_ATTRIBUTE]?: string;
} {
	return name ? { [DATA_AUTOMATION_ID_ATTRIBUTE]: name } : {};
}
